<div class="import-upload-card">
  <div *ngIf="!(hasResults$ | async)" class="hero-panel">
    <div class="header">
      <div class="header-copy">
        <span class="eyebrow">Carga masiva</span>
        <h3>Importar {{ entityLabel }}</h3>
        <div *ngIf="showDashboardWarning" class="warning-banner" role="status" aria-live="polite">
          <mat-icon>warning_amber</mat-icon>
          <span>
            Al importar accesos del dashboard, el archivo nuevo reemplazará los accesos existentes.
            Descarga el archivo actual antes de continuar para evitar pérdidas.
          </span>
        </div>
      </div>

      <button mat-icon-button type="button" class="close-button" (click)="close()" [disabled]="loading">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="upload-dropzone" [class.has-file]="!!selectedFile" [class.is-loading]="loading" (click)="!loading && fileInput.click()">
      <div class="dropzone-icon">
        <mat-icon>{{ selectedFile ? 'task_alt' : 'upload_file' }}</mat-icon>
      </div>

      <div class="dropzone-copy">
        <h4>{{ selectedFile ? 'Archivo listo para importar' : 'Arrastra o selecciona tu archivo' }}</h4>
        <p *ngIf="selectedFileName; else emptyState">{{ selectedFileName }}</p>
        <ng-template #emptyState>
          <p>Formatos admitidos: `.csv` y `.xlsx`.</p>
        </ng-template>
      </div>

      <button mat-stroked-button type="button" class="secondary-action" [disabled]="loading" (click)="$event.stopPropagation(); fileInput.click()">
        <mat-icon>attach_file</mat-icon>
        {{ selectedFile ? 'Cambiar archivo' : 'Seleccionar archivo' }}
      </button>
    </div>

    <input
      #fileInput
      id="import-file-input"
      type="file"
      accept=".csv,.xlsx"
      (change)="onFileSelected($event)"
      [disabled]="loading"
      hidden
    />

    <div class="status-row">
      <div *ngIf="selectedFile" class="file-pill">
        <mat-icon>description</mat-icon>
        <span>{{ selectedFileName }}</span>
      </div>

      <div *ngIf="validationError" class="feedback error">
        <mat-icon>error</mat-icon>
        <span>{{ validationError }}</span>
      </div>

      <div *ngIf="loading" class="feedback loading">
        <mat-spinner diameter="18"></mat-spinner>
        <span>Importando archivo...</span>
      </div>
    </div>

    <div class="action-row">
      <button mat-button type="button" (click)="close()" [disabled]="loading">Cancelar</button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="primary-action"
        (click)="uploadFile()"
        [disabled]="loading || !selectedFile"
      >
        <mat-icon>cloud_upload</mat-icon>
        Importar archivo
      </button>
    </div>
  </div>

  <div *ngIf="( hasResults$ | async )" class="result-card">
    <div class="result-header">
      <div>
        <span class="eyebrow">Respuesta procesada</span>
        <h4>Resultados de importación</h4>
      </div>

      <div class="result-actions">
        <button mat-stroked-button type="button" class="compact-button" (click)="resetImport()">
          <mat-icon>refresh</mat-icon>
          Importar otro
        </button>
        <button mat-icon-button type="button" class="close-button" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      
      <div class="result-summary" *ngIf="sumaryResult$ | async as sumaryResult">
        @for(summary of sumaryResult; track summary) {
        <div [class]="summary.styleClass" (click)="onChangeFilter(summary.filter)">
          <strong>{{ summary.count }}</strong>
          <span>{{ summary.label }}</span>
        </div>
        }
      </div>
    </div>

    <div *ngIf="hasResults$ | async; else emptyResults" class="results-grid">
      <article *ngFor="let result of visibleResults$ | async; trackBy: trackByIndex; let index = index" class="result-item">
        <div class="result-item__header">
          <div>
            <span class="result-index">Registro {{ index + 1 }}</span>
            <span class="result-state" [class.is-success]="isSuccessfulResult(result)" [class.is-warning]="!isSuccessfulResult(result)">
              {{ isSuccessfulResult(result) ? 'Procesado' : 'Revisar' }}
            </span>
          </div>
        </div>

        <div class="result-fields">
          <div *ngFor="let entry of getVisibleEntries(result)" class="field-row">
            <span class="field-label">{{ formatLabel(entry[0]) }}</span>
            <span *ngIf="!isObjectLike(entry[1])" class="field-value">
              {{ formatValue(entry[1]) }}
            </span>
            <pre *ngIf="isObjectLike(entry[1])" class="field-code">{{ formatValue(entry[1]) }}</pre>
          </div>
        </div>
      </article>
    </div>

    <ng-template #emptyResults>
      <div class="empty-results">
        <mat-icon>inventory_2</mat-icon>
        <p>La respuesta no incluyó elementos dentro de `results`.</p>
      </div>
    </ng-template>
  </div>
</div>
